const C = {
  bg:       "#0f172a",
  bgCard:   "#1e293b",
  primary:  "#3b82f6",
  text:     "#f1f5f9",
  textMid:  "#cbd5e1",
  textMuted:"#94a3b8",
  border:   "#334155",
  white:    "#ffffff",
};

const section = { marginBottom: 32 };
const h2Style = { fontSize: 20, fontWeight: 700, color: C.text, marginBottom: 10 };
const pStyle  = { fontSize: 14, color: C.textMid, lineHeight: 1.75, marginBottom: 10 };
const liStyle = { fontSize: 14, color: C.textMid, lineHeight: 1.75, marginBottom: 6 };

export const PrivacyPolicy = ({ onBack }) => (
  <div style={{ fontFamily: "'Inter', system-ui, sans-serif", background: C.bg, minHeight: "100vh", color: C.text }}>
    <main style={{ maxWidth: 720, margin: "0 auto", padding: "48px 24px 80px" }}>
      <button
        onClick={onBack}
        style={{ background: "none", border: "none", cursor: "pointer", color: C.primary, fontSize: 14, fontWeight: 500, fontFamily: "inherit", marginBottom: 24, padding: 0 }}
      >
        ← Voltar
      </button>

      <h1 style={{ fontSize: 32, fontWeight: 800, color: C.text, marginBottom: 8, letterSpacing: "-0.5px" }}>
        Política de Privacidade
      </h1>
      <p style={{ fontSize: 13, color: C.textMuted, marginBottom: 40 }}>
        Última atualização: 2 de abril de 2026
      </p>

      <div style={section}>
        <h2 style={h2Style}>1. Responsável pelo Tratamento</h2>
        <p style={pStyle}>
          A VillaGest é a entidade responsável pelo tratamento dos dados pessoais recolhidos através da plataforma
          villagest.pt. Para qualquer questão relacionada com a proteção de dados, pode contactar-nos através do
          email <a href="mailto:geral@villagest.pt" style={{ color: C.primary }}>geral@villagest.pt</a>.
        </p>
      </div>

      <div style={section}>
        <h2 style={h2Style}>2. Dados Pessoais Recolhidos</h2>
        <p style={pStyle}>Recolhemos os seguintes dados pessoais:</p>
        <ul style={{ paddingLeft: 20, margin: 0 }}>
          <li style={liStyle}><strong style={{ color: C.text }}>Dados de registo:</strong> nome, email, telefone e fração do condomínio</li>
          <li style={liStyle}><strong style={{ color: C.text }}>Dados de autenticação:</strong> credenciais de acesso (password armazenada de forma encriptada)</li>
          <li style={liStyle}><strong style={{ color: C.text }}>Dados de utilização:</strong> ocorrências criadas, documentos carregados e interações na plataforma</li>
          <li style={liStyle}><strong style={{ color: C.text }}>Dados de contacto:</strong> informação submetida através de formulários de contacto ou pré-registo</li>
        </ul>
      </div>

      <div style={section}>
        <h2 style={h2Style}>3. Finalidade do Tratamento</h2>
        <p style={pStyle}>Os dados pessoais são tratados para as seguintes finalidades:</p>
        <ul style={{ paddingLeft: 20, margin: 0 }}>
          <li style={liStyle}>Criação e gestão de contas de utilizador</li>
          <li style={liStyle}>Prestação dos serviços de gestão de condomínio</li>
          <li style={liStyle}>Comunicação com os utilizadores sobre a sua conta e o serviço</li>
          <li style={liStyle}>Gestão de pré-registos e lista de espera</li>
          <li style={liStyle}>Resposta a pedidos de informação</li>
        </ul>
      </div>

      <div style={section}>
        <h2 style={h2Style}>4. Base Legal</h2>
        <p style={pStyle}>
          O tratamento dos dados baseia-se no consentimento do utilizador (ao criar conta ou submeter formulários),
          na execução de contrato (prestação do serviço), e no interesse legítimo da VillaGest (segurança e melhoria da plataforma).
        </p>
      </div>

      <div style={section}>
        <h2 style={h2Style}>5. Armazenamento Local (Cookies e localStorage)</h2>
        <p style={pStyle}>A VillaGest não utiliza cookies de terceiros, analytics ou rastreamento. Utilizamos apenas armazenamento local (localStorage) para:</p>
        <ul style={{ paddingLeft: 20, margin: 0 }}>
          <li style={liStyle}><strong style={{ color: C.text }}>Sessão de autenticação</strong> — tokens geridos pelo Supabase para manter o login ativo (essencial)</li>
          <li style={liStyle}><strong style={{ color: C.text }}>Preferência de tema</strong> — modo claro/escuro (funcional)</li>
          <li style={liStyle}><strong style={{ color: C.text }}>Condomínio ativo</strong> — memoriza o condomínio selecionado (funcional)</li>
          <li style={liStyle}><strong style={{ color: C.text }}>Consentimento</strong> — regista a resposta ao aviso de cookies (essencial)</li>
          <li style={liStyle}><strong style={{ color: C.text }}>Última atividade</strong> — timestamp para auto-logout após 30 minutos de inatividade (essencial)</li>
          <li style={liStyle}><strong style={{ color: C.text }}>Notificações lidas</strong> — regista quais notificações do condomínio já foram visualizadas, para não serem apresentadas novamente (funcional)</li>
        </ul>
      </div>

      <div style={section}>
        <h2 style={h2Style}>6. Partilha de Dados</h2>
        <p style={pStyle}>
          Não vendemos, alugamos ou partilhamos os seus dados pessoais com terceiros para fins de marketing.
          Os dados são armazenados nos servidores da Supabase (infraestrutura na UE) e os emails transacionais
          são enviados através da Resend. Ambos os serviços cumprem o RGPD.
        </p>
      </div>

      <div style={section}>
        <h2 style={h2Style}>7. Período de Conservação</h2>
        <p style={pStyle}>
          Os dados pessoais são conservados enquanto a conta estiver ativa. Contas de demonstração são
          automaticamente eliminadas após 5 dias. Após eliminação da conta, todos os dados associados são removidos.
          Os dados de pré-registo e pedidos de informação são conservados por um período máximo de 12 meses.
        </p>
      </div>

      <div style={section}>
        <h2 style={h2Style}>8. Direitos dos Titulares</h2>
        <p style={pStyle}>Ao abrigo do RGPD, o utilizador tem os seguintes direitos:</p>
        <ul style={{ paddingLeft: 20, margin: 0 }}>
          <li style={liStyle}><strong style={{ color: C.text }}>Acesso</strong> — solicitar informação sobre os dados tratados</li>
          <li style={liStyle}><strong style={{ color: C.text }}>Retificação</strong> — corrigir dados incorretos ou incompletos</li>
          <li style={liStyle}><strong style={{ color: C.text }}>Apagamento</strong> — solicitar a eliminação dos seus dados</li>
          <li style={liStyle}><strong style={{ color: C.text }}>Portabilidade</strong> — receber os seus dados num formato estruturado</li>
          <li style={liStyle}><strong style={{ color: C.text }}>Oposição</strong> — opor-se ao tratamento em determinadas circunstâncias</li>
        </ul>
        <p style={{ ...pStyle, marginTop: 10 }}>
          Para exercer qualquer destes direitos, contacte-nos em <a href="mailto:geral@villagest.pt" style={{ color: C.primary }}>geral@villagest.pt</a>.
        </p>
      </div>

      <div style={section}>
        <h2 style={h2Style}>9. Segurança</h2>
        <p style={pStyle}>
          A VillaGest implementa medidas técnicas e organizativas adequadas para proteger os dados pessoais,
          incluindo encriptação em trânsito (HTTPS/TLS), encriptação de passwords, controlo de acesso
          baseado em perfis, e sessões com expiração automática por inatividade.
        </p>
      </div>

      <div style={{ ...section, marginBottom: 0 }}>
        <h2 style={h2Style}>10. Alterações a esta Política</h2>
        <p style={pStyle}>
          A VillaGest reserva-se o direito de atualizar esta política a qualquer momento.
          As alterações serão publicadas nesta página com a data de atualização revista.
        </p>
      </div>

      <div style={{ marginTop: 48, padding: "20px 24px", background: C.bgCard, borderRadius: 12, border: `1px solid ${C.border}` }}>
        <p style={{ fontSize: 13, color: C.textMuted, lineHeight: 1.7 }}>
          Para questões sobre proteção de dados ou exercício dos seus direitos, contacte-nos:<br />
          <a href="mailto:geral@villagest.pt" style={{ color: C.primary, fontWeight: 600 }}>geral@villagest.pt</a>
        </p>
      </div>
    </main>
  </div>
);
